/** Today as `YYYY-MM-DD` in the given IANA zone — `en-CA` formats dates in exactly that shape. */
export function todayIn(timezone: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: timezone }).format(new Date())
}
